import React, { useContext } from 'react';
import { UndoContext } from '../UndoContext';

const UndoSnackbar = () => {
  const { undo, hideUndo } = useContext(UndoContext);

  if (!undo?.visible) return null;

  return (
    <div style={styles.container} role="status" aria-live="polite">
      <div style={styles.message}>{undo.message}</div>
      <div style={styles.actions}>
        <button style={styles.button} onClick={() => { undo.onUndo && undo.onUndo(); hideUndo(); }}>Undo</button>
        <button style={styles.close} onClick={hideUndo}>✕</button>
      </div>
    </div>
  );
};

const styles = {
  container: {
    position: 'fixed',
    right: '20px',
    bottom: '20px',
    background: 'var(--color-bg)',
    color: 'var(--color-text)',
    padding: '10px 14px',
    borderRadius: '8px',
    boxShadow: '0 6px 18px rgba(0,0,0,0.12)',
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    zIndex: 9999,
  },
  message: { fontSize: '14px' },
  actions: { display: 'flex', gap: '8px', alignItems: 'center' },
  button: {
    background: 'transparent',
    border: '1px solid var(--color-border)',
    color: 'var(--color-text)',
    padding: '6px 10px',
    borderRadius: '6px',
    cursor: 'pointer',
  },
  close: { background: 'transparent', border: 'none', cursor: 'pointer', fontSize: '14px' },
};

export default UndoSnackbar;
